<template>
    <!-- 头部 -->
    <div class="header">
      <div class="main">
          <div class="logo" @click="goJLP">
              <img src="../../assets/image/logo.jpg" alt="">
          </div>
          <div class="name">
              <div class="title">{{districtInfo.title}}</div>
              <div class="info">The 12th District Games of Jiulongpo District, Chongqing</div>
          </div>
          <div class="start-time">
              <div class="time-name">
                  <div>距运动会</div>
                  <div>开幕</div>
              </div>
              <div class="time">
                  <div class="item">
                  <div class="num">{{showDateTime.d?showDateTime.d:'00'}}</div>
                  <div class="unit">天</div>
                  </div>
                  <div class="item">
                  <div class="num">{{showDateTime.h?showDateTime.h:'00'}}</div>
                  <div class="unit">小时</div>
                  </div>
                  <div class="item">
                  <div class="num">{{showDateTime.m?showDateTime.m:'00'}}</div>
                  <div class="unit">分钟</div>
                  </div>
                  <div class="item">
                  <div class="num">{{showDateTime.s?showDateTime.s:'00'}}</div>
                  <div class="unit">秒</div>
                  </div>
              </div>
          </div>
      </div>
      <div class="bannar" :class="isHome?'':'nobg'">
        <div class="bg-color"></div>
        <Bannar />
      </div>
    </div>
</template>

<script>
import Bannar from '@district/components/common/Bannar.vue'
import {overDateTime} from '../../utils/dateTime.js'

export default {
  props: {
    // isHome:{
    //   type:Boolean,
    //   default:false
    // }
  },
  components: {
    Bannar,
  },
  data () {
    return {
      overTime:'2023-3-18 21:57:56',//倒计时时间
      timer:null,//定时器
      showDateTime:{},//显示的倒计时
      isHome:false,
      districtInfo:{},//区运会信息
    }
  },
  mounted () {
    this.getQuerySeriesMatchDetail()
    this.getHome()
  },
  methods: {
    goJLP(){
      window.open('https://cqjlp.matchn.cn/',"_blank")
    },
    getHome (){
      if(this.$route.name=='Home'||this.$route.name=='SubHome'){
        this.isHome=true
      }else{
        this.isHome=false
      }
    },
    //开始计时
    beginOverTime (){
      this.timer=setInterval(()=> {
        let showDateTime=overDateTime(this.overTime)
        if(showDateTime.status==0){
          clearInterval(this.timer)
          return
        }else{
          this.showDateTime=showDateTime.time
        }
      }, 1000)
    },
    async getQuerySeriesMatchDetail(){
      try {
        let res =await this.$api.district.querySeriesMatchDetail();
        if(res.status==0){
            this.overTime=res.data.beginTime
            this.districtInfo=res.data
            localStorage.setItem("districtInfo",JSON.stringify(res.data))
            this.beginOverTime()
          }else{
            this.$message.error(res.msg);
          }
        } catch (error) {
      }
    },
  },
  watch: {
    $route (newValue, oldValue) {
      if(this.$route.name=='Home'||this.$route.name=='SubHome'){
        this.isHome=true
      }else{
        this.isHome=false
      }
    }
  },

}
</script>

<style lang="scss" scoped>
 //头部
.header {
  width: 100%;
  box-sizing: border-box;
  position: relative;
  .main {
    width: 1200px;
    margin: 0 auto;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    .logo {
      width: 132px;
      height: 118px;
      cursor: pointer;
    }

    .name {
      border-left: 1px solid #E7E7E7;
      padding-left: 40px;

      .title {
        font-size: 32px;
        font-weight: bold;
      }

      .info {
        font-size: 14px;
        font-weight: bold;
        margin-top: 5px;
      }
    }

    .start-time {
      width: 440px;
      height: 65px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: auto;
      box-sizing: border-box;

      .time-name {
        width: 110px;
        height: 65px;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        background-color: #009EDF;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }

      .time {
        width: 330px;
        height: 65px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        padding: 0 35px;
        box-sizing: border-box;
        border: 1px solid #009EDF;

        .item {
          color: #124584;
          font-weight: bold;

          .num {
            font-size: 22px;
          }

          .unit {
            font-size: 14px;
          }
        }
      }
    }
  }
    //导航
  .bannar {
    width: 100%;
    height: 100px;
    // background: url('../../assets/image/banner.jpg') no-repeat center center;
    position: absolute;
    left: 0;
    top: 120px;
    z-index: 1;
    .bg-color {
      width: 100%;
      height: 100px;
      background-color: rgba(18, 69, 132,0.5);
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/district/components/common/Header.vue